import { request } from '.';
import { setUiState } from './ui';

const defaultState = { businessMetrics: null };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function getOrganizationsBusinessMetrics(filters) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        let queryParams = [];
        queryParams.push(`filters=${filters}`);
        const url = `/internal/organizations/business-metrics?${queryParams.join(
          '&'
        )}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }
        return resolve(response.data);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/businessMetrics.js